/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeliverableFilesHeader_storageInfo$ref: FragmentReference;
declare export opaque type DeliverableFilesHeader_storageInfo$fragmentType: DeliverableFilesHeader_storageInfo$ref;
export type DeliverableFilesHeader_storageInfo = {|
  +storage: ?{|
    +activeStorageFinalFiles: ?number,
    +archivedStorageFinalFiles: ?number,
  |},
  +$refType: DeliverableFilesHeader_storageInfo$ref,
|};
export type DeliverableFilesHeader_storageInfo$data = DeliverableFilesHeader_storageInfo;
export type DeliverableFilesHeader_storageInfo$key = {
  +$data?: DeliverableFilesHeader_storageInfo$data,
  +$fragmentRefs: DeliverableFilesHeader_storageInfo$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeliverableFilesHeader_storageInfo",
  "type": "OrganizationNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "storage",
      "storageKey": null,
      "args": null,
      "concreteType": "StorageNode",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "activeStorageFinalFiles",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "archivedStorageFinalFiles",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '627b70e0d14c4e7fef4cf40f54e7b108';
module.exports = node;
